'use client'
import { Modal, useModal } from '@faceless-ui/modal'
export { Modal, useModal }
